import { IContainer } from '../../../common/container/IContainer';
import { ApplicationDetailDomain } from './application/info/store/ApplicationDetailDomain';
import { ApplicationDetailUI } from './application/info/store/ApplicationDetailUI';
import { ProjectInfoDomain } from './project/info/store/ProjectInfoDomain';
import { ProjectListDomain } from './project/list/store/ProjectListDomain';
import { extendProjectInfoDomainConstructor } from '../projectInfo/domain/extendProjectInfoDomainConstructor';
import { extendProjectListDomainConstructor } from '../projectList/domain/extendProjectListDomainConstructor';
import { signInPageContainer } from './login/signInPageContainer';

export function userPageContainer(container: IContainer): IContainer {
  container = signInPageContainer(container);

  const projectListDomainConstructor = container.get(ProjectListDomain);
  container.set(ProjectListDomain, extendProjectListDomainConstructor(projectListDomainConstructor));

  const projectInfoDomainConstructor = container.get(ProjectInfoDomain);
  container.set(ProjectInfoDomain, extendProjectInfoDomainConstructor(projectInfoDomainConstructor));

  container.set(ApplicationDetailUI, ApplicationDetailUI);
  container.set(ApplicationDetailDomain, ApplicationDetailDomain);

  return container;
}
